import { ViewItemFigure } from "./view";
import { EditItemFigure } from "./edit";

const ItemFigure = ({ edit = false, item, ...props }) => {
    if (edit && !['returned', 'kept', 'not_picked_up'].includes(item.status)) {
        return (
            <EditItemFigure item={item} {...props} />
        );
    }

    return (
        <ViewItemFigure item={item} {...props} />
    );
}

export { ItemFigure };
